import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function ChangeRoleDialog({ target, value, setValue, onClose, onConfirm }) {
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="gf-sharp border-zinc-200">
        <DialogHeader>
          <DialogTitle className="font-display font-bold tracking-tight">Change role</DialogTitle>
          <DialogDescription>For {target?.email}</DialogDescription>
        </DialogHeader>
        <Label className="gf-overline">Role</Label>
        <Select value={value} onValueChange={setValue}>
          <SelectTrigger data-testid="admin-role-select" className="gf-sharp mt-2 border-zinc-300 bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="gf-sharp">
            <SelectItem value="user">user</SelectItem>
            <SelectItem value="admin">admin</SelectItem>
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="gf-sharp border-zinc-300 uppercase font-bold tracking-wide">Cancel</Button>
          <Button onClick={onConfirm} data-testid="admin-role-confirm" className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide">
            Update role
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
